import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_chart_of_acc_glcode_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  // gl_code_1 => code, gl_code_2 => glcategory guid, gl_code_3 => accNo, name => glcode name, desc => glcode name
  gl_code_1: fromDatatype.VarcharDatatypeInterface;
  gl_code_2: fromDatatype.VarcharDatatypeInterface;
  gl_code_3: fromDatatype.VarcharDatatypeInterface;
  gl_code_4: fromDatatype.VarcharDatatypeInterface;
  gl_code_name: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_chart_of_acc_glcode_link_RowClass implements bl_fi_mst_chart_of_acc_glcode_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  // gl_code_1 => code, gl_code_2 => glcategory guid, gl_code_3 => accNo, name => glcode name, desc => glcode name
  gl_code_1: fromDatatype.VarcharDatatypeInterface;
  gl_code_2: fromDatatype.VarcharDatatypeInterface;
  gl_code_3: fromDatatype.VarcharDatatypeInterface;
  gl_code_4: fromDatatype.VarcharDatatypeInterface;
  gl_code_name: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
